<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="9" md="9" xl="9">
        <h2>User Growth</h2>
        <p class="mb-3" style="color: #485b79">Users statistics per month</p>
        <v-row class="my-2" align="center" justify="center">
          <v-col cols="12" lg="4" md="4" xl="4">
            <v-card class="pa-3" outlined>
              <h3>{{ totalUsers }} Total Users</h3>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4" md="4" xl="4">
            <v-card class="pa-3" outlined>
              <h3>{{ lastMonthGrowth }}% Last MoM Growth</h3>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4" md="4" xl="4">
            <v-card class="pa-3" outlined>
              <h3>{{ lastUsersGrowth }}% Last Users Growth</h3>
            </v-card>
          </v-col>
        </v-row>
        <apexchart :options="chartOptionsUserGrowth" :series="seriesUserGrowth" height="400" type="line"/>
      </v-col>
      <v-col v-if="tradeMetrics !== null" class="my-7" cols="12" lg="9" md="9" xl="9">
        <h2>Trade Growth</h2>
        <p class="mb-3" style="color: #485b79">Trades statistics per month</p>
        <v-row class="my-2" align="center" justify="center">
          <v-col cols="12" lg="4" md="4" xl="4">
            <v-card class="pa-3" outlined>
              <h3>{{ tradeMetrics.globalTotalTrades }} Total Trades</h3>
              <p class="my-0">{{ tradeMetrics.globalUniqueUsersWithTrades }} users with trades</p>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4" md="4" xl="4">
            <v-card class="pa-3" outlined>
              <h3>{{ tradeMetrics.globalAutomatedTrades }} Total Automated</h3>
              <p class="my-0">{{ tradeMetrics.globalUniqueUsersWithAutomatedTrades }} users with automated trades</p>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4" md="4" xl="4">
            <v-card class="pa-3" outlined>
              <h3>{{ tradeMetrics.globalImportedTrades }} Total Imported</h3>
              <p class="my-0">{{ tradeMetrics.globalUniqueUsersWithImportedTrades }} users with imported trades</p>
            </v-card>
          </v-col>
        </v-row>
        <apexchart :options="chartOptionsTradesGrowth" :series="seriesTradesGrowth" height="400" type="bar"/>
      </v-col>
      <v-col class="my-7" cols="12" lg="9" md="9" xl="9">
        <h2>B2C Metrics</h2>
        <p class="mb-3" style="color: #485b79">Single converted users (By Subscriptions)</p>
        <v-row class="my-2" align="center" justify="center">
          <v-col cols="12" lg="4" md="4" xl="4">
            <v-card class="pa-3" outlined>
              <h3>{{ basicUsers }} Free Users</h3>
              <p class="my-0">{{ basicPercentage }}% of total</p>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4" md="4" xl="4">
            <v-card class="pa-3" outlined>
              <h3>{{ boughtProUsers }} Bought PROs (Est.)</h3>
              <p class="my-0">{{ boughtPercentage }}% of total</p>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4" md="4" xl="4">
            <v-card class="pa-3" outlined>
              <h3>{{ giftProUsers }} Gift/Academy PROs (Est.)</h3>
              <p class="my-0">{{ giftPercentage }}% of total</p>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="9" md="9" xl="9">
        <h2>Countries Metrics</h2>
        <p class="mb-3" style="color: #485b79">Distribution of users per country ({{ totalCountries }} total)</p>
        <apexchart :options="chartOptionsCountries" :series="seriesCountries" height="420" type="bar"/>
      </v-col>
      <v-col cols="12" lg="9" md="9" xl="9">
        <h2>Channels vs Type of Trader</h2>
        <p class="mb-3" style="color: #485b79">Distribution of users per channel vs type</p>
        <apexchart :options="chartOptionsChannelsType" :series="seriesChannelsType" height="420" type="heatmap"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TradeRepository from '../../repositories/trades';
import VueApexCharts from 'vue-apexcharts';
import Vue from 'vue';

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
export default {
  name: "DashboardAnalytics",
  props: {
    users: Array,
  },
  data() {
    return {
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

      // Chart options
      chartOptionsUserGrowth: {},
      chartOptionsTradesGrowth: {},
      chartOptionsCountries: {},
      chartOptionsChannels: {},
      chartOptionsChannelsType: {
        dataLabels: {
          enabled: true
        },
        colors: ["#008FFB"],
      },

      // Series
      seriesUserGrowth: [],
      seriesTradesGrowth: [],
      seriesCountries: [],
      seriesChannels: [],
      seriesChannelsType: [],

      // Data
      totalCountries: 0,
      totalUsers: 0,
      lastMonthGrowth: 0,
      lastUsersGrowth: 0,
      basicUsers: 0,
      boughtProUsers: 0,
      giftProUsers: 0,
      tradeMetrics: null,
    };
  },
  computed: {
    basicPercentage() {
      return ((this.basicUsers / this.users.length) * 100).toFixed(2).toString();
    },
    boughtPercentage() {
      return ((this.boughtProUsers / this.users.length) * 100).toFixed(2).toString();
    },
    giftPercentage() {
      return ((this.giftProUsers / this.users.length) * 100).toFixed(2).toString();
    },
  },
  watch: {
    users() {
      this.refreshAnalytics();
    }
  },
  mounted() {
    this.refreshAnalytics();
  },
  methods: {
    refreshAnalytics() {
      this.usersGrowthAnalytics();
      this.tradesAnalytics();
      this.b2cAnalytics();
      this.countriesAnalytics();
      this.channelsAnalytics();
      this.channelsVsTypeOfTraderAnalytics();
    },
    usersGrowthAnalytics() {
      let dataMap = [];

      this.users.forEach((user) => {
        let dateArray = user.convertedFrom.split('-');
        let key = `${this.months[Number(dateArray[1]) - 1]}-${dateArray[0]}`;
        let foundMonth = dataMap.findIndex((month) => month.label === key);
        if (foundMonth !== -1) {
          dataMap[foundMonth].singleUsers++;
        } else {
          dataMap.push({
            label: key,
            singleUsers: 1,
          });
        }
      });

      this.totalUsers = this.users.length;
      let monthLabels = [], singleUsers = [], accumulativeUsers = [], movingAverage = [];
      let previousMonthUsers = 0, currentMonthUsers = 0;
      for (let i = 0; i < dataMap.length; i++) {
        dataMap[i].usersAccumulative = (i !== 0) ? dataMap[i].singleUsers + dataMap[i - 1].usersAccumulative : dataMap[i].singleUsers;
        singleUsers.push(dataMap[i].singleUsers);
        accumulativeUsers.push(dataMap[i].usersAccumulative);
        monthLabels.push(dataMap[i].label);
        movingAverage.push((i >= 3)? (this.calculateAverage([dataMap[i].usersAccumulative, dataMap[i-1].usersAccumulative, dataMap[i-2].usersAccumulative ])) : 0);
      }

      previousMonthUsers = dataMap[dataMap.length - 2].singleUsers;
      currentMonthUsers = dataMap[dataMap.length - 1].singleUsers;
      this.lastMonthGrowth = (((currentMonthUsers - previousMonthUsers) / previousMonthUsers) * 100).toFixed(2);
      this.lastMonthGrowth = Number(this.lastMonthGrowth).toString();
      this.lastUsersGrowth = ((currentMonthUsers / dataMap[dataMap.length - 1].usersAccumulative) * 100).toFixed(2).toString();

      // Set data
      this.seriesUserGrowth = [
        {
          name: "New Users",
          type: 'bar',
          data: singleUsers,
        },
        {
          name: "Total Users",
          type: 'line',
          data: accumulativeUsers,
        },
        /*{
          name: "Moving Average (3 Months)",
          data: movingAverage,
        }*/
      ];
      this.chartOptionsUserGrowth = {
        chart: {
          height: 400,
          type: 'line',
          zoom: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1]
        },
        stroke: {
          curve: 'straight',
          width: [0, 3],
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: monthLabels,
        }
      };
    },
    tradesAnalytics() {
      TradeRepository.getOverallMetrics().then((response) => {
        if(response.status < 400) {
          this.tradeMetrics = response.data;
          console.log(this.tradeMetrics);
          this.seriesTradesGrowth = [
            { name: 'Unique Users', data: [] },
            { name: 'Total Trades', data: [] },
            { name: 'Automated Trades', data: [] },
            { name: 'Imported Trades', data: [] },
          ];
          let categories = [];

          this.tradeMetrics.monthTradeMetrics.forEach((monthMetrics) => {
            let dateArray = monthMetrics.firstMonthDay.split('-');
            let key = `${this.months[Number(dateArray[1]) - 1]}-${dateArray[0]}`;
            categories.push(key);
            this.seriesTradesGrowth[0].data.push(monthMetrics.uniqueUsersWithTrades);
            this.seriesTradesGrowth[1].data.push(monthMetrics.totalTrades);
            this.seriesTradesGrowth[2].data.push(monthMetrics.automatedTrades);
            this.seriesTradesGrowth[3].data.push(monthMetrics.importedTrades);
          });

          this.chartOptionsTradesGrowth = {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                //columnWidth: '55%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: categories,
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return `${val}`;
                }
              }
            }
          };
        }
      });
    },
    b2cAnalytics() {
      this.boughtProUsers = this.users.filter((user) => new Date(user.proExpirationDate) > new Date() &&
          (user.subscriptionId !== null || user.epaycoCardId !== null)).length;
      this.giftProUsers = this.users.filter((user) => new Date(user.proExpirationDate) > new Date()).length - this.boughtProUsers;
      this.basicUsers = this.users.length - (this.boughtProUsers + this.giftProUsers);
    },
    countriesAnalytics() {
      let countriesData = [];
      let countriesLabels = [];
      let countriesCurated = this.groupBy(this.users, "country");
      countriesCurated = countriesCurated.sort((a, b) => (a.length < b.length) ? 1 : -1);

      this.totalCountries = 0;
      countriesCurated.forEach((country) => {
        if (country[0].country != null) {
          countriesData.push(country.length);
          countriesLabels.push(country[0].country);
          this.totalCountries++;
        }
      });

      // Set data
      this.seriesCountries = [{
        name: 'Country',
        data: countriesData
      }];
      this.chartOptionsCountries = {
        chart: {
          type: 'bar',
          height: 420
        },
        plotOptions: {
          bar: {
            horizontal: false,
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: countriesLabels,
        }
      };
    },
    channelsVsTypeOfTraderAnalytics() {
      let typeOfTraderCurated = this.groupBy(this.users, "type");
      this.seriesChannelsType = [];
      typeOfTraderCurated.forEach((typeOfTrader) => {
        let channelsCurated = this.groupBy(typeOfTrader, "arrivedFromChannel");
        let data = [];
        channelsCurated.forEach((channel) => {
          data.push({x: this.formatString(channel[0].arrivedFromChannel), y: channel.length});
        });
        this.seriesChannelsType.push({name: this.formatString(typeOfTrader[0].type), data: data});
      });
    },
    channelsAnalytics() {
      let channelData = [];
      let channelLabels = [];
      let channelsCurated = this.groupBy(this.users, "arrivedFromChannel");
      channelsCurated.forEach((channel) => {
        channelData.push(channel.length);
        channelLabels.push(channel[0].arrivedFromChannel);
      });

      // Set data
      this.seriesChannels = channelData;
      this.chartOptionsChannels = {
        chart: {
          type: 'donut',
          height: 480
        },
        labels: channelLabels,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              height: 450
            },
            legend: {
              show: true
            }
          }
        }]
      };
    },
    groupBy(arr, prop) {
      const map = new Map(Array.from(arr, obj => [obj[prop], []]));
      arr.forEach(obj => map.get(obj[prop]).push(obj));
      return Array.from(map.values());
    },
    formatString(string) {
      let stringFormatted = string.toString();
      stringFormatted = stringFormatted[0] + stringFormatted.slice(1).toLowerCase();
      stringFormatted = stringFormatted.replace('_', ' ').replace('_', ' ');
      return stringFormatted;
    },
    calculateAverage(array) {
      let sum = 0;
      array.forEach((element) => { sum += element; });
      return Number(sum / array.length).toFixed(1);
    },
  }
}
</script>

<style scoped>

</style>
